export interface UnloadingPointTruckDTO {
  transport_id: number;
  vehicle_plate: string;
  carrier: string;
  state: string;
  last_update: string | null;
  execution_order: number | null;
  current_action: string | null;
  urgent: number;
}

export interface UnloadingPointDTO {
  last_position: string;
  trucks_count: number;
  trucks: UnloadingPointTruckDTO[];
}

export interface UnloadingPointInfoDTO {
  timestamp: string;
  workshop: string;
  unloading_points: UnloadingPointDTO[];
  total_trucks: number;
}

export class UnloadingPointInfoListDTO {
  constructor(public data: UnloadingPointInfoDTO) {}
}
